import React, { useEffect, useState } from "react";
import "./OfferPage.scss"
import arrow from "../../../assets/arrow-black.svg"
import { useHistory, useParams } from "react-router";
import CategoryLayoutList from "../../../components/CategoryLayout/CategoryLayoutList";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../../utilities/helper";
import Pagination from "../../../components/Pagination/Pagination";
import OfferLayout from "./OfferLayout/OfferLayout";
import search from "../../../assets/search-v2.svg"
import close from "../../../assets/close.svg"
import { getAllData } from "../../../../../../../../redux/resturantWidgetSlice";

const getData = async () => {
    const result = await getAllData();

    const allItems = Array.isArray(result?.data?.Items) ? result.data.Items : [];
    const allCategories = Array.isArray(result?.data?.Categories) ? result.data.Categories : [];

    const categories = allCategories.filter(
        (category) => category.MetaData?.ShowAsOffer
    );

    const itemIDs = categories.flatMap(
        (category) => category.MenuEntities?.map(entity => entity.ID) || []
    );

    const items = allItems.filter(item =>
        itemIDs.includes(item.MenuItemID)
    );

    return items;
};
const OfferPage = () => {
    const [data, setData] = useState([])
    const [totalItems, setTotalItems] = useState(data.length);
    const [itemsData, setItemsData] = useState(data);
    const [menuData, setMenuData] = useState(itemsData?.slice(0, 12))
    const [allCategories, setAllCategories] = useState([])
    const [selected, setSelected] = useState(null)
    let params = useParams();

    useEffect(() => {
        localStorage.removeItem("QUANTITY")
        localStorage.removeItem("ITEM")
        localStorage.removeItem("MODQUANTITY")
        const fetchData = async () => {
            const items = await getData();
            setData(items);
            setItemsData(items)
            setMenuData(items?.slice(0, 12))
            setTotalItems(items?.length)
        };

        fetchData();
    }, [])
    useEffect(() => {
        getAllData().then((result) => {
            let cat = result?.data?.Categories?.filter(
                (category) => category.MetaData?.ShowAsOffer
            );
            setAllCategories(result?.data?.Categories);
            if (cat.length > 0) {
                if (params.id !== "all") {
                    let item = cat.find((cat) => cat.MenuCategoryID === params.id)
                    setSelected(item)
                } else {
                    setSelected(null)
                    localStorage.setItem("selected_offer", "null")

                }
            }
        });
    }, [params, params.id]);

    let categories = allCategories.filter(
        (category) => category.MetaData?.ShowAsOffer === true
    );
    const [searchValue, setSearchValue] = useState("")
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 12
    const history = useHistory()
    useEffect(() => {
        window.scrollTo(0, 0);
        localStorage.setItem("selected_cat", "offers")
    }, []);
    const handleData = () => {
        if (selected) {
            let menuIds = selected.MenuEntities?.map(entity => entity.ID)
            const promotionalItems = data.filter(item =>
                menuIds.includes(item.MenuItemID)
            );
            if (searchValue === "") {
                setItemsData(promotionalItems)
                setMenuData(promotionalItems.slice(0, 12))
                setTotalItems(promotionalItems.length)
            } else {
                const searchedItems = promotionalItems.filter(item =>
                    item.Title.en.toLowerCase().includes(searchValue.toLowerCase())
                );
                setItemsData(searchedItems)
                setMenuData(searchedItems.slice(0, 12))
                setTotalItems(searchedItems.length)
            }
            setCurrentPage(1)


        } else {
            if (searchValue === "") {
                setItemsData(data)
                setMenuData(data.slice(0, 12))
                setTotalItems(data.length)
            } else {
                const searchedItems = data.filter(item =>
                    item.Title.en.toLowerCase().includes(searchValue.toLowerCase())
                );
                setItemsData(searchedItems)
                setMenuData(searchedItems.slice(0, 12))
                setTotalItems(searchedItems.length)
            }
            setCurrentPage(1)

        }
    }
    useEffect(() => {
        handleData()
    }, [selected, searchValue])
    return (
        <div className="OfferPage" >
            <div className="header-contentcontainer">
                <div className="header-left">
                    <div className="heder-text-cont">
                        <img alt="" src={arrow} className="back-arr"
                            onClick={() => {
                                history.push("/")
                            }} />
                        <div className="header-txt">All Special Offers</div>
                    </div>
                    <div className="subheader-text-cont">Discover our latest deals and promotions to save on your favorite meals</div>
                </div>
                <div className="header-righ-search-filter-cont">
                    <div className="search-container-re">
                        <img alt="" src={search} className="seacrh-ico" />
                        <input
                            value={searchValue}
                            onChange={(e) => {
                                setSearchValue(e.target.value)
                            }}
                            placeholder="Search for offers..." />
                        {searchValue !== "" && <img alt="" src={close} className="close-ico" onClick={() => {
                            setSearchValue("")
                        }} />}

                    </div></div>
            </div>

            <CategoryLayoutList
                data={categories}
                selected={selected}
                setSelected={setSelected}
                showIcon={false}
                allText="All Offers"
                offerItems={true}

            />
            {menuData.length > 0 ? <div className="items-layout">
                <OfferLayout layout={"layout4"} items={
                    menuData || []
                }
                    showHeader={false} />
            </div>
                :
                <div className="rec-empty">
                    <img alt="" src={search} className="empty-searc-ic" />
                    <div className="empt-hdr">No items found</div>
                    <div className="empt-sub-hdr">We couldn't find any items matching your search criteria. Try adjusting your filters or search terms.</div>

                </div>}
            {totalItems > 12 &&
                <div className="pagination-container">
                    <Pagination
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        currentPage={currentPage}
                        onPageChange={(e) => {
                            setCurrentPage(e)
                            setMenuData(itemsData.slice(12 * (e - 1), 12 * e));
                            window.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                            });

                        }}
                    />
                </div>}
        </div >)
}
export default OfferPage